<iq-central-front-end-navbar></iq-central-front-end-navbar>

<div class="container">
    <div id="certificate-wrapper">
        <div class="d-flex align-items-center justify-content-between">
            <span class="font20 click mt-5 " routerLink="../">
                <i class="fa fa-arrow-left mr-3"></i> Go Back
            </span>
            <span class="font20 click mt-5 d-flex align-items-center" (click)="downloadCertificate()">
                Download Certificate

                <i class="fa fa-download ml-2" *ngIf="!isLoading"></i>
                <span class="ml-2"><mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner></span>

            </span>


        </div>

        <div class="certificate" id="certificate">
            <img class="top-right" src="assets/icons/certificate/top-illustration.svg" alt="top">
            <img class="top-left" src="assets/icons/certificate/prop.svg" alt="top">
            <img class="bottom" src="assets/icons/certificate/bottom-illustration.svg" alt="bottom">
            <img class="logo" src="assets/icons/certificate/logos.svg" alt="IQCentral X Quomodo Systems" />


            <div class="content">
                <p class="certificate-id">Certificate ID - {{ certificateData?.certificateId }}</p>

                <h1 class="certificate-title">CERTIFICATE</h1>
                <div class="subtitle">OF COMPLETION</div>

                <h2 class="recipient-name">{{ certificateData?.fullName }}</h2>

                <div class="line"></div>

                <p class="description">
                    You have successfully completed <strong>{{ certificateData?.courseName }}</strong><br />
                    and developed expertise in the <strong>{{certificateData?.subjectArea}}</strong>
                </p>

                <div class="footer">
                    <div class="signature">
                        <p>NILL</p>
                        <div class="line short-line"></div>
                        <p>SIGNATURE</p>
                    </div>

                    <div class="date">
                        <p>{{ certificateData?.issuedDate | date : 'dd/MM/yyyy'}}</p>
                        <div class="line short-line"></div>
                        <p>Date Issued</p>
                    </div>
                </div>


            </div>
        </div>
    </div>
</div>